import React, { useEffect, useState } from 'react';
import { FaFacebookF, FaYoutube, FaInstagram, FaLinkedinIn, FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Footer() {
  const [footerData, setFooterData] = useState({
    companyName: 'Aman LifeStyle ',
    phones: ['+8809647001250', '+8801345688562'],
    emails: ['amanlifestylebd@gmail.com', 'amanlifestylebd@gmail.com'],
    facebookLink: 'https://www.facebook.com/elevateemart',
    instagramLink: 'https://www.instagram.com/elevateemart',
    youtubeLink: 'https://www.youtube.com/@elevateemart',
    xLink: 'https://www.linkedin.com/company/yourcompany',
    officeAddress: 'Madhubag, Mogbazar, Dhaka, Bangladesh',
    aboutDescription: 'Aman LifeStyle is your trusted online shopping platform. We are committed to providing high-quality products and the best customer service.',
    ctaHeading: 'Ready to Experience Excellence?',
    ctaDescription: 'Join thousands of satisfied customers and discover why Aman LifeStyle is the preferred choice for your needs.',
    ctaButtonText: 'Get Started Today',
    ctaButtonLink: '/product',
    quickLinks: [
      { text: 'About Us', url: '/about' },
      { text: 'Refund Policy', url: '/refund-policy' },
      { text: 'My Orders', url: '/order-history' },
      { text: 'Privacy Policy', url: '/privacy-policy' }
    ],
    customerServiceLinks: [
      { text: 'Secure Payment', url: '#' },
      { text: 'Fast Delivery', url: '#' },
      { text: '100% Protection Guarantee', url: '#' },
      { text: 'Easy Return Process', url: '#' }
    ],
    bottomLinks: [
      { text: 'Terms of Service', url: '#' },
      { text: 'Privacy Policy', url: '#' },
      { text: 'Help Center', url: '#' }
    ]
  });

  useEffect(() => {
    AOS.init({
      offset: 100,
      duration: 600,
      once: true,
    });
    AOS.refresh();
  }, []);

  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        const response = await fetch('https://bazar-wala-main-server-974485829900.asia-south1.run.app/api/footer');
        const result = await response.json();

        if (result.success && result.footer) {
          setFooterData({
            companyName: result.footer.companyName || 'E-Business',
            phones: (result.footer.phones && result.footer.phones.length > 0)
              ? result.footer.phones
              : ['+8809647001250', '+8801345688562'],
            emails: (result.footer.emails && result.footer.emails.length > 0)
              ? result.footer.emails
              : ['elevatemart.contact@gmail.com', 'e-business.help@gmail.com'],
            facebookLink: result.footer.facebookLink || 'https://www.facebook.com/elevateemart',
            instagramLink: result.footer.instagramLink || 'https://www.instagram.com/elevateemart',
            youtubeLink: result.footer.youtubeLink || 'https://www.youtube.com/@elevateemart',
            xLink: result.footer.xLink || 'https://www.linkedin.com/company/yourcompany',
            officeAddress: result.footer.officeAddress || 'Madhubag, Mogbazar, Dhaka, Bangladesh',
            aboutDescription: result.footer.aboutDescription || 'Aman LifeStyle is your trusted online shopping platform. We are committed to providing high-quality products and the best customer service.',
            ctaHeading: result.footer.ctaHeading || 'Ready to Experience Excellence?',
            ctaDescription: result.footer.ctaDescription || 'Join thousands of satisfied customers and discover why Aman LifeStyle is the preferred choice for your needs.',
            ctaButtonText: result.footer.ctaButtonText || 'Get Started Today',
            ctaButtonLink: result.footer.ctaButtonLink || '/product',
            quickLinks: (result.footer.quickLinks && result.footer.quickLinks.length > 0)
              ? result.footer.quickLinks
              : [
                { text: 'About Us', url: '/about' },
                { text: 'Refund Policy', url: '/refund-policy' },
                { text: 'My Orders', url: '/order-history' },
                { text: 'Privacy Policy', url: '/privacy-policy' }
              ],
            customerServiceLinks: (result.footer.customerServiceLinks && result.footer.customerServiceLinks.length > 0)
              ? result.footer.customerServiceLinks
              : [
                { text: 'Secure Payment', url: '#' },
                { text: 'Fast Delivery', url: '#' },
                { text: '100% Protection Guarantee', url: '#' },
                { text: 'Easy Return Process', url: '#' }
              ],
            bottomLinks: (result.footer.bottomLinks && result.footer.bottomLinks.length > 0)
              ? result.footer.bottomLinks
              : [
                { text: 'Terms of Service', url: '#' },
                { text: 'Privacy Policy', url: '#' },
                { text: 'Help Center', url: '#' }
              ]
          });
        }
      } catch (error) {
        console.error('Error fetching footer data:', error);
      }
    };

    fetchFooterData();
  }, []);

  const currentYear = new Date().getFullYear();

  const fontStyle = { fontFamily: "'Półtawski Nowy', serif" };

  return (
    <footer className="bg-white text-gray-800 mt-20 mb-0 md:mb-0" style={fontStyle}>

      {/* Call to Action Section */}
      <section
        className="py-12 text-white"
        style={{ background: "linear-gradient(135deg, #1a1b1f 0%, #25262b 100%)", borderTop: "3px solid #CD0302" }}
      >
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" style={{ ...fontStyle, color: "#F5D19D" }}>
            {footerData.ctaHeading}
          </h2>
          <p className="text-lg md:text-xl mb-8" style={{ ...fontStyle, color: "#d1cfc9" }}>
            {footerData.ctaDescription}
          </p>
          
           <a href={footerData.ctaButtonLink}
            className="inline-block font-bold text-lg px-10 py-3 transition-all duration-300"
            style={{
              ...fontStyle,
              background: "linear-gradient(135deg, #F88702 0%, #F0C400 100%)",
              color: "#1a1b1f",
              clipPath: "polygon(12px 0%, calc(100% - 12px) 0%, 100% 50%, calc(100% - 12px) 100%, 12px 100%, 0% 50%)",
              boxShadow: "4px 4px 0px #4F7E17",
              letterSpacing: "0.04em",
            }}
            onMouseEnter={e => {
              e.currentTarget.style.background = "linear-gradient(135deg, #CD0302 0%, #F88702 100%)";
              e.currentTarget.style.color = "#fff";
              e.currentTarget.style.boxShadow = "6px 6px 0px #4F7E17";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.background = "linear-gradient(135deg, #F88702 0%, #F0C400 100%)";
              e.currentTarget.style.color = "#1a1b1f";
              e.currentTarget.style.boxShadow = "4px 4px 0px #4F7E17";
            }}
          >
            {footerData.ctaButtonText}
          </a>
        </div>
      </section>

      {/* Main Footer Content */}
      <div className="bg-white py-12 px-6" style={{ borderTop: "3px solid #F5D19D" }}>
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* About Us Section */}
          <div data-aos="fade-up" data-aos-delay="0">
            <h3 className="text-base font-bold mb-4" style={{ ...fontStyle, color: "#CD0302" }}>
              Get to Know Us
            </h3>
            <p className="text-sm leading-relaxed mb-4 text-gray-700" style={fontStyle}>
              {footerData.aboutDescription}
            </p>
            <div className="flex gap-3 mt-4">
              {[
                { href: footerData.facebookLink, icon: <FaFacebookF className="text-base" /> },
                { href: footerData.youtubeLink, icon: <FaYoutube className="text-base" /> },
                { href: footerData.instagramLink, icon: <FaInstagram className="text-base" /> },
                { href: footerData.xLink, icon: <FaXTwitter className="text-base" /> },
              ].map(({ href, icon }, i) => (
                
                 <a key={i}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 flex items-center justify-center transition-all duration-300"
                  style={{
                    background: "#f3f3f3",
                    clipPath: "polygon(6px 0%, calc(100% - 6px) 0%, 100% 50%, calc(100% - 6px) 100%, 6px 100%, 0% 50%)",
                    color: "#25262b",
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.background = "#F88702";
                    e.currentTarget.style.color = "#fff";
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.background = "#f3f3f3";
                    e.currentTarget.style.color = "#25262b";
                  }}
                >
                  {icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links Section */}
          <div data-aos="fade-up" data-aos-delay="100">
            <h3 className="text-base font-bold mb-4" style={{ ...fontStyle, color: "#CD0302" }}>
              Make Money with Us
            </h3>
            <ul className="space-y-2">
              {footerData.quickLinks.map((link, index) => (
                <li key={index}>
                  
                 <a  href={link.url}
                    className="text-sm text-gray-700 hover:underline transition-colors duration-200"
                    style={fontStyle}
                    onMouseEnter={e => e.currentTarget.style.color = "#F88702"}
                    onMouseLeave={e => e.currentTarget.style.color = "#374151"}
                  >
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Customer Service Section */}
          <div data-aos="fade-up" data-aos-delay="200">
            <h3 className="text-base font-bold mb-4" style={{ ...fontStyle, color: "#CD0302" }}>
              Let Us Help You
            </h3>
            <ul className="space-y-2">
              {footerData.customerServiceLinks.map((link, index) => (
                <li key={index}>
                  
                  <a   href={link.url}
                    className="text-sm text-gray-700 hover:underline transition-colors duration-200"
                    style={fontStyle}
                    onMouseEnter={e => e.currentTarget.style.color = "#F88702"}
                    onMouseLeave={e => e.currentTarget.style.color = "#374151"}
                  >
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Section */}
          <div data-aos="fade-up" data-aos-delay="300">
            <h3 className="text-base font-bold mb-4" style={{ ...fontStyle, color: "#CD0302" }}>
              Contact Us
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-2 text-sm">
                <FaPhoneAlt className="mt-1 flex-shrink-0" style={{ color: "#F88702" }} />
                <div className="flex flex-col gap-1">
                  {footerData.phones.map((phone, index) => (
                    <a key={index} href={`tel:${phone}`} className="text-gray-700 transition-colors" style={fontStyle}
                      onMouseEnter={e => e.currentTarget.style.color = "#F88702"}
                      onMouseLeave={e => e.currentTarget.style.color = "#374151"}
                    >
                      {phone}
                    </a>
                  ))}
                </div>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <FaEnvelope className="mt-1 flex-shrink-0" style={{ color: "#F88702" }} />
                <div className="flex flex-col gap-1">
                  {footerData.emails.map((email, index) => (
                    <a key={index} href={`mailto:${email}`} className="text-gray-700 transition-colors break-all" style={fontStyle}
                      onMouseEnter={e => e.currentTarget.style.color = "#F88702"}
                      onMouseLeave={e => e.currentTarget.style.color = "#374151"}
                    >
                      {email}
                    </a>
                  ))}
                </div>
              </li>
              <li className="flex items-start gap-2 text-sm">
                <FaMapMarkerAlt className="mt-1 flex-shrink-0" style={{ color: "#F88702" }} />
                <span className="text-gray-700" style={fontStyle}>{footerData.officeAddress}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* SSL Commerce Payment Logo */}
      <div className="bg-white py-8 md:py-12 border-t border-gray-200">
        <div className="w-full px-4 md:px-6 flex justify-center">
          <img
            src="https://securepay.sslcommerz.com/public/image/SSLCommerz-Pay-With-logo-All-Size-01.png"
            alt="SSL Commerce Payment Gateway"
            className="w-full max-w-5xl h-auto object-contain"
          />
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="py-6 px-6 border-t pb-6 md:pb-6 max-md:pb-24"
        style={{ background: "#1a1b1f", borderColor: "#CD0302" }}
      >
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
            <p style={{ ...fontStyle, color: "#9ca3af" }}>
              © {currentYear} {footerData.companyName}. All rights reserved.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              {footerData.bottomLinks.map((link, index) => (
                <React.Fragment key={index}>
                  
                 <a   href={link.url}
                    className="transition-colors"
                    style={{ ...fontStyle, color: "#9ca3af" }}
                    onMouseEnter={e => e.currentTarget.style.color = "#F0C400"}
                    onMouseLeave={e => e.currentTarget.style.color = "#9ca3af"}
                  >
                    {link.text}
                  </a>
                  {index < footerData.bottomLinks.length - 1 && (
                    <span style={{ color: "#F88702" }}>|</span>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>

    </footer>
  );
}

export default Footer;